<div class="sp-provider-card__avatar-rating">
  <span class="portrait"><img src="<%= provider.imageUrl %>" /></span>
  <sp-rating class="rating" rating="<%= provider.rating %>" url="<%= provider.url %>" info-url="<%= provider.ratingInfoUrl %>" target="_blank"></sp-rating>
</div>
<div class="sp-provider-card__details">
  <div class="name sp-provider-card__title"><%= provider.name %></div>
  <div class="credentials sp-provider-card__subtitle"><%= provider.credentialsForLabel.join(', ') %></div>

  <div class="address-name"><%= address.displayName %></div>
  <% if (!address.virtual) { %>
    <div class="address">
      <%= address.streetAddress %> <br />
      <%= address.city %>, <%= address.state %> <%= address.zipCode %>
      <a class="map-link" href="<%= address.mapUrl %>" target="_blank"><%= I18n.suggestion_selector.show_in_google_maps %></a>
    </div>
  <% } %>
</div>
<% if (!address.virtual) { %>
<div class="sp-provider-card__map" data-behaviour="sp-provider-card-map-container"></div>
<% } %>
